import { clsx } from "clsx";
import type { CSSProperties, FC } from "react";

import style from "./Shortcut.module.css";

export interface ShortcutProps {
  label: string;
  className?: string;
  style?: CSSProperties;
}

export const Shortcut: FC<ShortcutProps> = (props) => {
  return (
    <kbd className={clsx(style.shortcut, props.className)} style={props.style}>
      {props.label}
    </kbd>
  );
};
